class PaginationAjax extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      paginateButton: "[load-more-pagination]",
      listItem: "[product-list-items]",
      list: "[product-list]",
      productCountDisplay: "[product-count-display]",
    };
    this.totalNumOfPages = 0;
    this.currentPageIndex = 0;
    this.fetchProductUrl = null;
    this.totalProducts = 0;
    this.loadedProducts = 0;
    this.init();
  }

  init() {
    this.paginateButton = this.querySelector(this.selectors.paginateButton);
    this.productCountDisplay = this.querySelector(this.selectors.productCountDisplay);

    if (this.paginateButton) {
      const newButton = this.paginateButton.cloneNode(true);
      this.paginateButton.parentNode.replaceChild(newButton, this.paginateButton);
      this.paginateButton = newButton;

      this.totalProducts = parseInt(this.paginateButton.getAttribute("data-total-products")) || 0;
      this.updateProductCountDisplay();
      this.paginateButton.addEventListener("click", () => { this.loadMore(); });
    }

    if (!this.productCountDisplay) {
      console.error("Product count display element not found!");
    }
  }

  async loadMore() {
    // Show the loader and hide button text
    this.showLoader(true);

    this.totalNumOfPages = parseInt(
      this.paginateButton.getAttribute("data-size")
    );
    this.currentPageIndex = parseInt(
      this.paginateButton.getAttribute("data-current")
    );

    if (this.currentPageIndex < this.totalNumOfPages) {
      try {
        if (!this.fetchProductUrl) {
          this.fetchProductUrl = this.paginateButton.getAttribute("data-url");
        }
        if (this.fetchProductUrl) {
          console.log("Fetching products from:", this.fetchProductUrl);
          const response = await fetch(this.fetchProductUrl);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          console.log(response);
          const data = await response.text();
          const htmlDocument = new DOMParser().parseFromString(
            data,
            "text/html"
          );
          this.updateDom(htmlDocument);
          this.currentPageIndex++;

          // Update the current page index attribute
          this.paginateButton.setAttribute(
            "data-current",
            this.currentPageIndex
          );

          if (this.currentPageIndex >= this.totalNumOfPages) {
            this.handleLastPage();
          }
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        // Hide the loader after loading
        this.showLoader(false);
      }
    } else {
      this.handleLastPage(); // Safeguard in case the button is still active
      // Hide the loader if already at the last page
      this.showLoader(false);
    }
  }

  updateDom(doc) {
    const paginateButton = doc.querySelector(this.selectors.paginateButton);
    this.collectionProd = doc.querySelectorAll(this.selectors.listItem);
    this.collectionProdList = document.querySelector(this.selectors.list);
    if (this.collectionProdList && this.collectionProd) {
      this.collectionProd.forEach((element) => {
        if (element) {
          this.collectionProdList.appendChild(element.cloneNode(true));
          this.loadedProducts++;
        }
      });
    } else {
      console.error("Product list or new products not found in the response!");
    }

    // Update the product count display
    this.updateProductCountDisplay();

    if (paginateButton) {
      this.fetchProductUrl = paginateButton.getAttribute("data-url");
    } else {
      this.fetchProductUrl = null;
    }
  }
  updateProductCountDisplay() {
    const defaultProductCount =
      parseInt(this.paginateButton.getAttribute("data-product-count")) || 0;
    const productType =
      this.paginateButton.getAttribute("data-type");
    console.log(this.loadedProducts)
    const defaultCount = defaultProductCount + this.loadedProducts;
    if (this.productCountDisplay) {
      this.productCountDisplay.textContent = `You're viewing ${defaultCount} of ${this.totalProducts} ${productType}`;
    }
  }
  showLoader(isLoading) {
    const buttonText = this.paginateButton.querySelector(".button-text");
    const spinner = this.paginateButton.querySelector(".spinner");

    if (isLoading) {
      buttonText.style.display = "none"; // Hide button text
      spinner.style.display = "inline"; // Show loader
    } else {
      buttonText.style.display = "inline"; // Show button text
      spinner.style.display = "none"; // Hide loader
    }
  }
  handleLastPage() {
    console.log("All products loaded. Disabling the Load More button...");
    if (this.paginateButton) {
      this.paginateButton.setAttribute("disabled", true);
      this.paginateButton.style.display = "none";
    }
  }
}

customElements.define("pagination-ajax", PaginationAjax);
